import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MarkerDetailsWrapper from './MarkerDetailsWrapper';
import MarkerDetailsContent from './MarkerDetailsContent';

class MapDetailsMarkerWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      markerInfoLocation: false,
    };

    this.onMarkerInfoToggle = this.onMarkerInfoToggle.bind(this);
  }


  onMarkerInfoToggle(locationId) {
    if (locationId === this.state.markerInfoLocation) {
      return this.setState(() => ({
        markerInfoLocation: false,
      }));
    }

    return this.setState(() => ({
      markerInfoLocation: locationId,
    }));
  }

  getMarkers() {
    const { markerInfoLocation } = this.state;

    return this.props.markersArray.filter(e => (e.latitude && e.longitude)).map((data, index) => {
      const openByClick = (markerInfoLocation === data.id);

      return (
        <MarkerDetailsWrapper
          key={data.id}
          onInfoToggle={this.onMarkerInfoToggle}
          locationId={data.id}
          lat={data.latitude}
          lng={data.longitude}
          isActive={openByClick}
          index={index}
        >
          <MarkerDetailsContent
            area={data.area_humanized}
            title={data.address_title}
            imageUrl={data.primary_photo_url}
            link={data.url}
            stars_rating={data.stars_rating}
          />
        </MarkerDetailsWrapper>
      );
    });
  }

  render() {
    const markers = this.getMarkers();

    return (
      <div>
        {markers}
      </div>

    );
  }
}

MapDetailsMarkerWrapper.propTypes = {
  markersArray: PropTypes.arrayOf(PropTypes.shape),
};

MapDetailsMarkerWrapper.defaultProps = {
  markersArray: [],
};


export default MapDetailsMarkerWrapper;
